const EvidenceSource = ({
    source
}) => {
    if (!source?.title) return <span>—</span>;

    return (
        <p>
            {source.title}
        </p>
    )
};

export default EvidenceSource;
